import { useSelector } from 'react-redux';

import { isDiscountMortgageBannerEnabled } from '../../selectors/discountMortgage';
import { DiscountMortgageBannerContainer } from '../DiscountMortgageBannerContainer';
import { BrokerConsultantBannerContainer } from '../BrokerConsultantBannerContainer';
import { useRotatingBanner } from './useRotatingBanner';
import { MortgageRateHikeBannerContainer } from '../MortgageRateHikeBannerContainer';
import { selectIsBannerSlotClosed } from '../../selectors/mortgageRateHikeBanner';

export const BannerContainer = () => {
  const isDiscountMortgageBannerAvailable = useSelector(isDiscountMortgageBannerEnabled);
  const isBannerSlotClosed = useSelector(selectIsBannerSlotClosed);
  const rotatingBanner = useRotatingBanner();

  if (isBannerSlotClosed) {
    return null;
  }

  if (isDiscountMortgageBannerAvailable) {
    return <DiscountMortgageBannerContainer />;
  }

  if (rotatingBanner === 'mortgageRateHike') {
    return <MortgageRateHikeBannerContainer />;
  }

  if (rotatingBanner === 'broker') {
    return <BrokerConsultantBannerContainer />;
  }

  return null;
};
